export default function TopThreeColLayout({ leftContent, middleContent, rightContent }) {
  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 md:gap-4 lg:gap-10 mt-0 lg:mt-0 ">

      {/* Left Column */}
      <div className="min-h-[248px] rounded-[15px] overflow-hidden">
        {leftContent}
      </div>

      {/* Middle Column */}
      <div className="min-h-[248px] rounded-[15px] overflow-hidden">
        {middleContent}
      </div>

      {/* Right Column */}
      <div className="min-h-[248px] rounded-[15px] overflow-hidden md:col-span-2 xl:col-span-1">
        {rightContent}
      </div>

    </div>
  );
}
